import * as NavConst from '../components/constants/NavigationConstants';
import * as SweetAlert from '../components/common/utilities/ConfirmationAlert';
import { PERMISSION, GENERIC_PAGINATED_KEY_VALUE_LIST, getApiPath, DELETE, MODULE, LIST } from '../api/ApiConst';
import apiCaller from "../api/ApiCaller";

export const Permission = {
  basePath: "permission",
  tableDataUrl:LIST,
  label: "Permission",
  attributes: [{ name: "id", value: "id", type: "text", position: 0, formAttribute: false },
  { name: "Label", value: "label", type: "text", position: 1, formAttribute: true, className: "form-control input-default" },
  {name: "Module", value: "moduleId", type: "select", position: 2, formAttribute: true, isStatic: false, basePath: "module",
    dataListFunction: () => {
      const options = []
      var jsonRequest = { "page": 0, "size": 200, searchFilters: [], sortRules: [] };
      apiCaller.callPostApi(getApiPath(MODULE, GENERIC_PAGINATED_KEY_VALUE_LIST), jsonRequest, {}, (response) => {
      response.data.map((d) => {
          options.push({ value: d.value, label: d.key })
        });
      }, (error) => {
        console.error(error);
      });
      return options
    }
  },
  { name: "Type", value: "type", type: "select", position: 3, formAttribute: true, isStatic: true, dataList: [
    {value:"create", label:"Create"},
    {value:"delete", label:"Delete"},
    {value:"get", label:"Get"},
    {value:"edit", label:"Edit"},
    {value:"export", label:"Export"},
    {value:"import", label:"Import"},
    {value:"list", label:"List"},
    {value:"read", label:"Read"},
    {value:"write", label:"Write"},
    {value:"all", label:"All"},
    ],
  className: "form-control input-default" },
  { name: "Url", value: "url", type: "text", position: 3, formAttribute: true, className: "form-control input-default" },
  { name: "Default Value", value: false, type: "checkbox", i: 4, formAttribute: true, className: "form-control input-default" }
  ],
  actions: [
    { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
    {
      name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
      navigatePath: getApiPath(PERMISSION, DELETE), replaceData: "{recordId}"
    },
    { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
    { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
  ]
};
